import gql from "graphql-tag";

export const DELETE_ONE_TELEGRAM_BUTTON = gql`
  mutation ($id: ID!) {
    deleteOneTelegramButton(input: { id: $id }) {
      id
    }
  }
`;
